import axios from "axios";
import config from "../../config";
import { getAuthToken } from "../../utils/authStorage";
import { PALETTE } from "../hpc/overview/overviewUtils";

/** GET /teba/admin/dashboard/overview{path}; empty params are dropped. */
export const tebaOverviewApi = async (path, params = {}) => {
  const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""));
  const token = getAuthToken();
  const res = await axios.get(`${config.apiBaseUrl}/teba/admin/dashboard/overview${path}`, {
    params: clean,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return res.data;
};

export const PAYMENT_METHOD_META = {
  cash: { label: "Cash", color: PALETTE.green },
  bank_transfer: { label: "Bank transfer", color: PALETTE.blue },
  card: { label: "Card", color: PALETTE.purple },
  online: { label: "Online", color: PALETTE.teal },
  qr_payment: { label: "QR payment", color: PALETTE.pink },
  not_recorded: { label: "Not recorded", color: PALETTE.grey },
};

export const ATTENDANCE_METHOD_META = {
  qr: { label: "QR", color: PALETTE.purple },
  rfid: { label: "RFID card", color: PALETTE.blue },
  member_id: { label: "Membership ID", color: PALETTE.teal },
  not_recorded: { label: "Not recorded", color: PALETTE.grey },
};

export const INACTIVE_BUCKET_META = {
  "14_29": { label: "14–29 days", color: PALETTE.amber },
  "30_59": { label: "30–59 days", color: "#ff9f43" },
  "60_plus": { label: "60+ days", color: PALETTE.red },
  never: { label: "Never checked in", color: PALETTE.grey },
};

export const methodLabel = (meta, key) => meta[key]?.label || key || "Not recorded";
